import { createOidcAuthClient } from '@phoenix/auth';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ConsoleApp } from './App';
import { consoleConfig } from './config';

const authClient = createOidcAuthClient({
  authority: consoleConfig.oidcAuthority,
  clientId: consoleConfig.oidcClientId,
});

const container = document.getElementById('root');
if (container) {
  createRoot(container).render(
    <StrictMode>
      <ConsoleApp authClient={authClient} apiBaseUrl={consoleConfig.apiBaseUrl} />
    </StrictMode>,
  );
}
